import { EP_GET_INSTOCK_LIST, EP_GET_OUTOFSTOCKS, EP_GET_SEND_ITEM_HISTORIES, EP_SEND_ITEM_TO_OTHER, EP_TOGGLE_STOCK_ADJUSTED_FLAG} from '../constants/endpointConstants';
import api from './Api';

const getOutOfStocksData = async () => {
    const response = await api.get(`${EP_GET_OUTOFSTOCKS}`);
    return response.data;
}

const getInstockProducts = async (formData) => {
    const response = await api.post(`${EP_GET_INSTOCK_LIST}`, formData);
    return response.data;
}

const toggleStockAdjustedFlag = async (formData) => {
    const response = await api.post(`${EP_TOGGLE_STOCK_ADJUSTED_FLAG}`, formData);
    return response.data;
}

const sendItemToOther = async (formData) => {
    const response = await api.post(`${EP_SEND_ITEM_TO_OTHER}`, formData);
    return response.data;
}

const getSendItemHistories = async (formData) => {
    const response = await api.post(`${EP_GET_SEND_ITEM_HISTORIES}`, formData);
    return response.data;
}
//#endregion


export {getOutOfStocksData, getInstockProducts, toggleStockAdjustedFlag, sendItemToOther, getSendItemHistories}